import { useEffect, useState } from "react";
import { isMobileAtom } from "../atoms";

/** Set once the first client effect ran, i.e. after the initial hydration. */
let hasHydrated = false;

export function useIsMobile(width: number = 768) {
  // The first client render must match the server render (which only knows
  // the user agent), otherwise HeaderDesktop/HeaderMobile and the footer
  // variants swap during hydration and React throws away the whole SSR tree
  // (e.g. phones in landscape, "desktop site" mode, iPad in-app browsers).
  // The effect below switches to the real screen width right after hydration.
  const [isMobile, setMobile] = useState<boolean>(() =>
    hasHydrated && typeof window !== "undefined"
      ? screen.width < width
      : isMobileAtom.value,
  );

  const setIsMobile = (value: boolean) => {
    setMobile(value);
  };

  useEffect(() => {
    // Function to check if the viewport is mobile
    const checkIsMobile = () => {
      setIsMobile(screen.width < width);
    };

    // Run on mount
    hasHydrated = true;
    checkIsMobile();

    // Add resize event listener
    window.addEventListener("resize", checkIsMobile);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", checkIsMobile);
  }, [width]);

  return isMobile;
}
